import React, { useContext } from 'react'
import StepFigure from '../StepFigure'
import { CarOrderingContext } from "../../../CarOrdering";
import Price from "../../Misc/Price";

export default function Step1() {
  const {
    car,
    steps,
    strings,
  } = useContext(CarOrderingContext)

  const step = steps.find(step => step.id === 1)
  const informationElements = car.informationList.map((information, index) => (
    <div key={index} className="car-overview__detail">
      <p className="car-overview__detail-title">{information.title}</p>
      <p className="car-overview__detail-value" dangerouslySetInnerHTML={{ __html: information.content }} />
    </div>
  ))

  return (
    <div id='step-1'>
      <StepFigure/>

      <div className='form sticky'>
        <h1 className='mobile-config-title config-title'>
          {step.title}
        </h1>

        {typeof step?.description === 'string' && step.description.length > 0 && (
          <>
            <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: step.description }}/>
            <div className='config-seperator'/>
          </>
        )}

        <div className="car-overview__content-wrapper">
          <div className="car-overview__header">
            <div className="car-overview__header-left">
              <div className="car-overview__brand">{car.brand}</div>
              <div className="car-overview__model">{car.model}</div>
            </div>
            <div className="car-overview__header-right">
              <Price className="car-overview__price" price={car.price} showSuffix={false}/>
              <div className="car-overview__price-details">{strings.price.inclVat}</div>
            </div>
          </div>
          <div className="car-overview__inner-wrapper">
            <div className="car-overview__inner">
              <div className="car-overview__column">
                {informationElements}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
